export const ANONYMOUS_NICKNAME = "익명의 프롱이";

export const DEFAULT_PROFILE = "/svg/userProfile.svg";

export const REPOSITORY_URL = "https://github.com/prgrms-fe-devcourse/FEDC5_DevNamu_eunsu";
